import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const InquiryContext = createContext();

const inquiryApi = axios.create({ baseURL: '/api/inquiries' });
const authApi    = axios.create({ baseURL: '/api/inquiry-auth' });

inquiryApi.interceptors.request.use(config => {
  const token = localStorage.getItem('inquiryToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function InquiryProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('inquiryToken');
    if (token) {
      authApi.get('/verify', { headers: { Authorization: `Bearer ${token}` } })
        .then(r => setUser(r.data.user))
        .catch(() => { localStorage.removeItem('inquiryToken'); setUser(null); })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (username, password) => {
    const res = await authApi.post('/login', { username, password });
    localStorage.setItem('inquiryToken', res.data.token);
    setUser({ username: res.data.username });
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('inquiryToken');
    setUser(null);
  };

  return (
    <InquiryContext.Provider value={{ user, loading, login, logout, api: inquiryApi }}>
      {children}
    </InquiryContext.Provider>
  );
}

export const useInquiry = () => useContext(InquiryContext);
